import React, { useMemo, useState } from 'react';
import dayjs from 'dayjs';
import DataTable from '../../../../components/LynDataTable/DataTable';
import { Button, Form, Tooltip } from 'antd';
import viewIcon from '../../../../assets/images/table-icons/view_blue.svg';
import { useSendControlDataMutation } from 'store/features/api/apiSlice';
import { useLocation } from 'react-router-dom';
import LeaseRecordViewModal from './CustomComponents/LeaseRecordViewModal';
import { Box } from '@mui/material';
import ConfirmModal from 'components/modal/ConfirmModal';
import Notification01Icon from 'assets/icons/notification01Icon';
import { formatNumber } from './CustomComponents/LeaseUtils/helper';

const LeaseTable = ({
	leaseControlData = [],

	screen = 'CREATE',
}) => {
	const form = Form.useFormInstance();
	const { state } = useLocation();
	// const identityData = form.getFieldsValue();
	const leaseId = form.getFieldValue('leaseId');

	const [getJournalEntryData, { data: journalEntryData, isLoading: isJournalEntryDataLoading }] = useSendControlDataMutation();
	const [getActionRequiredData] = useSendControlDataMutation();
	const [showJournalEntryModal, setShowJournalEntryModal] = useState(false);

	const [rowId, setRowId] = useState(null);
	const [actionRequiredConfirmModal, setActionRequiredConfirmModal] = useState(false);
	// const [rowIndexColorMapping, setRowIndexColorMapping] = useState({});

	const [tableUpperLeftExtraInfo, setTableUpperLeftExtraInfo] = useState({});

	const handleEyeButton = async (index) => {
		setTableUpperLeftExtraInfo(
			screen?.toLowerCase() === 'create'
				? {
						leaseTitle: form.getFieldValue('leaseTitle'),
						leasePeriod: index + 1,
					}
				: {
						leaseId,
						leaseTitle: form.getFieldValue('leaseTitle'),
						leasePeriod: index + 1,
					}
		);
		let calculateData = {};
		let identityData = {};
		const formData = form.getFieldsValue();

		if (screen?.toLowerCase() === 'create') {
			calculateData = {
				advanceAmount: formData?.advanceAmount,
				leaseTerm: formData?.leaseTerm,
				discountRate: formData?.initialDiscountRate,
				startYear: String(formData?.leaseStartDate?.year()),
				escalation: 0,
				startMonth: String(formData?.leaseStartDate?.month() + 1),
				paymentFrequency: formData?.paymentFrequency,
				paymentTime: formData?.paymentModality,
				advanceDuration: formData?.advanceAmounts?.filter((item) => item !== 0)?.length,
				startDay: String(formData?.leaseStartDate?.date()),
				upfrontLeasePayment: formData?.upfrontLeasePayment,
				initialDirectCost: formData?.initialDirectCost,
				securityDeposit: formData?.securityDeposit,
				endOfFinancialYear: formData?.endOfFinancialYear,
				advanceAmounts: formData?.advanceAmounts,
				grossRents: formData?.grossRents,
				changes: [],
			};
			identityData = {
				leaseStartDate: formData?.leaseStartDate,
				leaseTitle: formData?.leaseTitle,
				lessorName: formData?.lessorName,
				leaseTerm: formData?.leaseTerm,
				leaseEndDate: formData?.leaseEndDate,
				paymentModality: formData?.paymentModality,
				leaseType: formData?.leaseType,
				initialDiscountRate: formData?.initialDiscountRate,
				grossRentList: formData?.grossRentList,
				paymentFrequency: formData?.paymentFrequency,
				advanceAmountList: formData?.advanceAmountList,
				advanceAmount: formData?.advanceAmount,
				advanceAmounts: formData?.advanceAmounts,
				upfrontLeasePayment: formData?.upfrontLeasePayment,
				initialDirectCost: formData?.initialDirectCost,
				securityDeposit: formData?.securityDeposit,
				grossRents: formData?.grossRents,
				changes: formData?.changes?.map((item) => {
					return {
						...item,
						inputChangeAdvance: item?.inputChangeAdvanceAmounts?.reduce((acc, curr) => acc + curr, 0),
					};
				}),
				modifiedDateTime: dayjs(),
				paymentModalityLabel: formData?.paymentModality?.toLowerCase() === 'start' ? 'Advance basis' : 'Acrual Basis',
				endOfFinancialYear: formData?.endOfFinancialYear,
				lastModifiedDate: dayjs(),
				grossRentListSet: formData?.grossRentListSet,
				advanceAmountListSet: formData?.advanceAmountListSet,
				advanceDuration: formData?.advanceAmounts?.filter((item) => item !== 0)?.length,
			};

			const payloadData = {
				calculateData,
				identityData,
				scheduledIndex: index + 1,
			};
			const convertJson = JSON.stringify(payloadData);
			const convertBase64 = btoa(convertJson);
			const formattedPayload = {
				data: convertBase64,
				processCode: state?.processCode,
				scriptName: 'lease-controller-schedule-findata2',
				payloadData: payloadData,
			};
			try {
				await getJournalEntryData(formattedPayload);
			} catch (error) {
				console.error('Error in handleEyeButton:', error);
			}
		} else {
			const effectiveChanges = form.getFieldValue('changes')?.filter((_, index) => index !== 0);
			calculateData = {
				advanceAmount:
					formData?.changes?.[0]?.inputChangeAdvanceAmounts?.reduce((accumulator, currentValue) => accumulator + currentValue, 0) ?? 0,
				leaseTerm: formData?.changes?.[0]?.inputChangeLeaseTerm,
				discountRate: formData?.changes?.[0]?.inputChangeDiscountRate,
				startDay: String(formData?.leaseStartDate?.date()),
				startMonth: String(formData?.leaseStartDate?.month() + 1),
				startYear: String(formData?.leaseStartDate?.year()),
				escalation: 0,
				paymentFrequency: formData?.changes?.[0]?.paymentFrequency,
				paymentTime: formData?.changes?.[0]?.paymentTime,
				advanceDuration: formData?.changes?.[0]?.inputChangeAdvanceAmounts?.filter((item) => item !== 0)?.length,
				upfrontLeasePayment: formData?.changes?.[0]?.upfrontLeasePayment,
				initialDirectCost: formData?.changes?.[0]?.initialDirectCost,
				securityDeposit: formData?.securityDeposit,
				endOfFinancialYear: formData?.endOfFinancialYear,
				advanceAmounts: formData?.changes?.[0]?.inputChangeAdvanceAmounts,
				grossRents: formData?.changes?.[0]?.inputChangeGrossRents,
				changes: effectiveChanges.map((item, index) => {
					if (index === effectiveChanges.length - 1) {
						return {
							...item,
							upfrontLeasePayment: formData?.upfrontLeasePayment,
							initialDirectCost: formData?.initialDirectCost,
							securityDeposit: formData?.securityDeposit,
						};
					}
					return {
						...item,
					};
				}),
				grossRent: 0,
			};
			const { changes, ...rest } = formData;
			identityData = {
				...rest,
				changes: changes.map((item) => {
					return {
						...item,
						inputChangeAdvance: item?.inputChangeAdvanceAmounts?.reduce((acc, curr) => acc + curr, 0),
					};
				}),
			};
			const payloadData = {
				calculateData,
				identityData,
				scheduledIndex: index + 1,
			};
			const convertJson = JSON.stringify(payloadData);
			const convertBase64 = btoa(convertJson);
			const formattedPayload = {
				data: convertBase64,
				processCode: state?.processCode,
				scriptName: 'lease-controller-schedule-findata2',
				payloadData: payloadData,
			};
			try {
				await getJournalEntryData(formattedPayload);
			} catch (error) {
				console.error('Error in handleEyeButton:', error);
			}
		}
	};
	const handleActionRequiredButton = async () => {
		const payloaddata = {
			id: rowId,
		};
		const convertJson = JSON.stringify(payloaddata);
		const convertBase64 = btoa(convertJson);
		const formattedPayload = {
			data: convertBase64,
			processCode: state?.processCode,
			scriptName: 'lease-controller-schedule-ready',
			payloadData: payloaddata,
		};

		try {
			await getActionRequiredData(formattedPayload);
		} catch (error) {
			console.error('Error in handleActionRequiredButton:', error);
		}
		// }
	};

	const columnData = useMemo(
		() => [
			{
				id: 'date',
				width: '5%',
				align: 'center',
				accessor: 'date',
				cellAlign: 'center',
				Header: 'Date',
			},
			{
				id: 'period',
				width: '5%',
				align: 'center',
				accessor: 'period',
				cellAlign: 'center',
				Header: 'Period',
			},
			{
				id: 'grossRent',
				width: '5%',
				align: 'center',
				accessor: 'grossRent',
				cellAlign: 'center',
				Header: 'Gross Rent',
			},
			{
				id: 'advanceAmount',
				width: '5%',
				align: 'center',
				accessor: 'advanceAmount',
				cellAlign: 'center',
				Header: 'Advance Amount',
			},
			{
				id: 'netPay',
				width: '5%',
				align: 'center',
				accessor: 'netPay',
				cellAlign: 'center',
				Header: 'Net pay',
			},
			{
				id: 'ibr',
				width: '5%',
				align: 'center',
				accessor: 'ibr',
				cellAlign: 'center',
				Header: 'IBR (%)',
			},
			{
				id: 'discountFactor',
				width: '5%',
				align: 'center',
				accessor: 'discountFactor',
				cellAlign: 'center',
				Header: 'Discount Factor',
			},
			{
				id: 'rentExp',
				width: '5%',
				align: 'center',
				accessor: 'rentExp',
				cellAlign: 'center',
				Header: 'PV of Rent',
			},

			{
				id: 'openLeaseLiability',
				width: '5%',
				align: 'right',
				accessor: 'openLeaseLiability',
				cellAlign: 'right',
				Header: 'Open Lease Liability',
			},
			{
				id: 'interestExp',
				width: '5%',
				align: 'right',
				accessor: 'interestExp',
				cellAlign: 'right',
				Header: 'Interest Expense',
			},

			{
				id: 'payment',
				width: '5%',
				align: 'right',
				accessor: 'payment',
				cellAlign: 'right',
				Header: 'Payment',
			},
			{
				id: 'closingLeaseLiability',
				width: '5%',
				align: 'right',
				accessor: 'closingLeaseLiability',
				cellAlign: 'right',
				Header: 'Closing Lease Liability',
			},
			{
				id: 'adjustment',
				width: '5%',
				align: 'right',
				accessor: 'adjustment',
				cellAlign: 'right',
				Header: 'Adjustment',
			},
			{
				Header: 'Action',
				Cell: (cell) => {
					return (
						<Box
							sx={{
								display: 'flex',
								justifyContent: cell?.row?.original?.processStatus?.toLowerCase() === 'returned' ? 'space-between' : 'center',
								alignItems: 'center',
							}}
						>
							<div style={{ textAlign: 'center' }}>
								<Tooltip title="Check">
									<Button
										type="text"
										icon={<img src={viewIcon} width={16} height={16} alt="view" />}
										onClick={(e) => {
											e.stopPropagation();

											handleEyeButton(cell?.row?.index);
											setShowJournalEntryModal(true);
										}}
									></Button>
								</Tooltip>
							</div>
							{cell?.row?.original?.processStatus?.toLowerCase() === 'returned' && (
								<div style={{ textAlign: 'center' }}>
									<Tooltip title="Action Required">
										<Button
											type="text"
											icon={<Notification01Icon width={16} height={16} color="#B00020" />}
											onClick={(e) => {
												e.stopPropagation();

												setRowId(cell?.row?.original?._id);
												setActionRequiredConfirmModal(true);
											}}
										></Button>
									</Tooltip>
								</div>
							)}
						</Box>
					);
				},
				disableSortBy: 'true',
				align: 'center',
			},
		],
		[]
	);
	const tableData = Array.isArray(leaseControlData)
		? leaseControlData?.map((item, index) => ({
				...item,
				date: dayjs(item.date).format('YYYY-MM-DD'),
				id: index,
				period: index + 1,
				grossRent: formatNumber(item.grossRent, 2),
				discountFactor: formatNumber(item.discountFactor, 4),
				rentExp: formatNumber(item.rentExp, 2),
				interestExp: formatNumber(item.interestExp, 2),
				openLeaseLiability: formatNumber(item.openLeaseLiability, 2),
				interest: formatNumber(item.interest, 2),
				payment: formatNumber(item.payment, 2),
				closingLeaseLiability: formatNumber(item.closingLeaseLiability, 2),
				adjustment: formatNumber(item.adjustment, 2),
				advanceAmount: formatNumber(item.advanceAmount, 2),
				netPay: formatNumber(item.netPay, 2),
				ibr: formatNumber(item.ibr, 2),
			}))
		: [];
	const ModalData = {
		head: 'Returned Lease - Required Action',
	};

	const mappedRowIndexColorMapping = useMemo(() => {
		// Define the color mapping for different processStatus values
		const statusColorMap = {
			Pending: '#E6F0FF', // light blue
			Unprocessed: '#E6F0FF', // light blue
			Reversed: '#ffcccc', // light red
			Returned: '#FFFDE6', // light yellow
			Recorded: '#E6FFE6', // light green
			Processed: '#E6F0FF', // light blue
		};

		// Create a new mapping object
		let newMapping = {};

		// Loop through the leaseControlData to populate the mapping
		Array.isArray(leaseControlData) &&
			leaseControlData?.forEach((lease, index) => {
				if (lease.processStatus) {
					newMapping[index] = {
						rowColor: statusColorMap[lease.processStatus] || '#FCFCFC',
					};
				}
			});

		return newMapping;
	}, [leaseControlData]);
	const rowIndexColorMapping = mappedRowIndexColorMapping;

	return (
		<>
			{Array.isArray(tableData) && tableData?.length !== 0 && (
				<DataTable
					xlsxFileName={`${leaseId}_date`}
					COLUMNS={columnData || []}
					DATA={tableData || []}
					firstColStrick={false}
					pagination={false}
					rowIndexColorMapping={rowIndexColorMapping}
					pageSize={tableData.length}
				/>
			)}

			{showJournalEntryModal && (
				<LeaseRecordViewModal
					showModal={showJournalEntryModal}
					setShowModal={setShowJournalEntryModal}
					checkResponseData={journalEntryData?.responseData || []}
					tableUpperLeftExtraInfo={tableUpperLeftExtraInfo}
					isLoading={isJournalEntryDataLoading}
				/>
			)}
			{actionRequiredConfirmModal && (
				<ConfirmModal
					showModal={actionRequiredConfirmModal}
					setShowModal={setActionRequiredConfirmModal}
					modalData={ModalData}
					handleSubmit={handleActionRequiredButton}
				/>
			)}
		</>
	);
};

export default LeaseTable;
